import { friendlyErrorMessage } from '@/core/lib/dbError'

import { extractBewilligungOnGate, type ExtractionBewilligungForm } from '@/core/api/extraction'
import { ok, technical, type Result } from '@/core/lib/result'

export type BewilligungForm = ExtractionBewilligungForm

export async function extractBewilligung(
  path: string | Blob,
): Promise<Result<BewilligungForm>> {
  try {
    return ok(await extractBewilligungOnGate(path))
  } catch (error) {
    return technical(friendlyErrorMessage(error, 'Bewilligungs-Erkennung fehlgeschlagen.'))
  }
}
